<app-header></app-header>

<!-- Mobile View -->
<div class="contacts-page mobile-view">
  <!-- Gradient ellipses for mobile view -->
  <div class="gradient-ellipse-mobile ellipse-mobile-1"></div>
  <div class="gradient-ellipse-mobile ellipse-mobile-2"></div>
  <div class="gradient-ellipse-mobile ellipse-mobile-3"></div>

  <header class="contacts-header">
    <h1>Contacts</h1>
  </header>

  <section class="contacts-list">
    <div class="contact-card" *ngFor="let c of contacts">
      <div class="contact-title">{{ c.name }}</div>
      <a class="contact-phone" href="#" (click)="onDial(c.phone, $event)">
        <img src="/assets/images/Phone.png" alt="Phone" width="16" height="16" />
        <span>{{ c.phone | slice:0:5 }} {{ c.phone | slice:5 }}</span>
      </a>
    </div>
  </section>

  <app-navbar [items]="[
    { id: 'profile', label: 'Profile', selectedIcon: '/assets/images/Person_Selected.png', unselectedIcon: '/assets/images/Person_Unselected.png' },
    { id: 'home', label: 'Homepage', selectedIcon: '/assets/images/Home_Selected.png', unselectedIcon: '/assets/images/Home_Unselected.png' },
    { id: 'contacts', label: 'Contacts', selectedIcon: '/assets/images/Contact_Selected.png', unselectedIcon: '/assets/images/Contact_Unselected.png' }
  ]" [selectedId]="'contacts'" (selectedIdChange)="onNavChange($event)"></app-navbar>
</div>

<!-- Desktop View -->
<div class="contacts-desktop-view">
  <!-- Gradient ellipses for desktop view -->
  <div class="gradient-ellipse-desktop ellipse-desktop-1"></div>
  <div class="gradient-ellipse-desktop ellipse-desktop-2"></div>
  <div class="gradient-ellipse-desktop ellipse-desktop-3"></div>
  <div class="gradient-ellipse-desktop ellipse-desktop-4"></div>
  <div class="gradient-ellipse-desktop ellipse-desktop-5"></div>
  <div class="gradient-ellipse-desktop ellipse-desktop-6"></div>

  <div class="contacts-desktop-heading">Contacts</div>
  <div class="contacts-grid">
    <div class="contact-card-desktop" *ngFor="let c of contacts">
      <div class="contact-name">{{ c.name }}</div>
      <div class="contact-phone-row">
        <button type="button" class="copy-icon-btn" (click)="onCopy(c.phone)" aria-label="Copy phone number">
          <img src="/assets/images/Copy_Icon.png" alt="Copy number" class="copy-icon">
        </button>
        <button type="button" class="contact-number" (click)="onCopy(c.phone)" [attr.aria-label]="'Copy phone number ' + (c.phone | slice:0:5) + ' ' + (c.phone | slice:5)">
          {{ c.phone | slice:0:5 }} {{ c.phone | slice:5 }}
        </button>
      </div>
    </div>
  </div>
</div>


